import { ShipDataType } from "@/types/apiTypes";
import { getToken } from "@/utils/authHelpers";
import axios from "axios";
import { API_BASE_URL } from "@/utils/api";

export const associateShipToProjectApi = async (
  ship: ShipDataType,
  projectId: string,
): Promise<void> => {
  const token = await getToken();
  if (!token) {
    throw new Error("Authorization token is required");
  }

  try {
    await axios.post(
      `${API_BASE_URL}/projects/${projectId}/ships/${ship.id}`,
      {},
      { headers: { Authorization: `Bearer ${token}` } },
    );
    /*
    notifications.show({
      title: "Ship added to project",
      message: `${ship.ship_name} has been added to the project.`,
      color: "success",
    });
     */
  } catch (error) {
    console.error("Failed to add ship to project", error);
    throw error;
  }
};
